import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FrontService } from '../../front.service';
import { Menu } from '../../../models/menu.model';
import { VideoService } from '../../../services/video.service';
import { Subscription } from 'rxjs/Subscription';
import { Video } from '../../../models/video.model';
@Component({
  selector: 'app-training-videos',
  templateUrl: './training-videos.component.html',
  styleUrls: ['./training-videos.component.css']
})
export class TrainingVideosComponent implements OnInit {
  menus: Menu[] = [];
  subscription: Subscription;
  videos: Video[] = [];

  accordion;

  @ViewChild('previewModal') previewModal: ElementRef;

  constructor(private frontService: FrontService, private videoService: VideoService) { }

  ngOnInit() {
    let $this = this;
    this.frontService.loadMenu(this.menus);

    this.videoService.httpGetVideos({
      provider: ['all', this.frontService.authService.auth.provider]
    });

    this.subscription = this.videoService.videosChanged.subscribe(
      (videos: Video[]) => {
        this.videos = videos;
      }
    );

    jQuery('#previewElement').on('hide.bs.modal', function (e) {
      $this.previewModal.nativeElement.querySelector('.modal-body iframe').src = '';
    });

  }

  onPreview(link: string) {
    this.previewModal.nativeElement.querySelector('.modal-body iframe').src = link;
  }

}



// WEBPACK FOOTER //
// ./src/app/front/help/training-videos/training-videos.component.ts